<script setup>
import { ref } from 'vue';
import { registerSW } from 'virtual:pwa-register';

const showUpdateDialog = ref(false);

// Registrar o Service Worker
registerSW({
  onNeedRefresh() {
    showUpdateDialog.value = true; // Exibe o modal de atualização
  },
  onOfflineReady() {
  //  alert('O sistema agora está disponível offline.');
  },
});
</script>

<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>

    <v-dialog v-model="showUpdateDialog" persistent max-width="400">
      <v-card>
        <v-card-title>Atualização Disponível</v-card-title>
        <v-card-text>
          <p>Uma nova versão está disponível. Atualize para continuar com as melhorias mais recentes.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="location.reload()">Atualizar</v-btn>
          <v-btn text @click="showUpdateDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
